import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_earInfection_redFlagSymptoms',
    label: 'Are you experiencing any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Unusually stiff neck', key: 'stiff_neck' },
        {
          value: 'Unusually severe headache or feeling confused',
          key: 'severe_headache_confused'
        },
        { value: 'Bloody fluid draining from the ear', key: 'bloody_drainage' },
        { value: 'Sudden hearing loss', key: 'sudden_hearing_loss' },
        { value: 'Ear pain WITH facial drooping', key: 'ear_pain_facial_drooping' },
        {
          value:
            'Severe ear pain WITH swelling or WITH redness behind the ear',
          key: 'severe_pain_swelling_redness'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_fever',
    label: 'Do you currently have a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No fever', key: 'no_fever' },
        { value: 'Mild fever (100.4–102°F)', key: 'mild_fever' },
        { value: 'High fever (≥102°F)', key: 'high_fever' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_earsAffected',
    label: 'Which ear(s) are affected?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'One ear', key: 'one_ear' },
        { value: 'Both ears', key: 'both_ears' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_symptoms',
    label: 'Which symptoms are you experiencing? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Deep ear pain', key: 'deep_ear_pain' },
        {
          value:
            'Pain that worsens when pulling the outer ear or pressing the ear opening',
          key: 'pain_pulling_ear'
        },
        { value: 'Muffled or decreased hearing', key: 'muffled_hearing' },
        { value: 'Feeling of fullness or pressure', key: 'fullness_pressure' },
        { value: 'Itching in the ear canal', key: 'itching_ear_canal' },
        { value: 'Thick or pus-like drainage', key: 'thick_pus_drainage' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_past7Days',
    label: 'In the past 7 days, have you:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Been swimming or used a hot tub', key: 'swimming_hot_tub' },
        {
          value: 'Had a cold, sinus infection, or sore throat',
          key: 'cold_sinus_sore_throat'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_jawToothPain',
    label:
      'Do you have jaw pain, tooth pain, or pain that worsens with chewing?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_dentalProcedures',
    label: 'Have you had any dental procedures within the last 14 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_earInfection_additionalComments'
    }
  },
  {
    field: 'zalud_earInfection_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_earInfection_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_earInfection_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludEarInfectionQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
